/* eslint-disable @typescript-eslint/no-explicit-any */
import { LineExtensionChannel } from './LineExtensionChannel'
import { FBExtensionChannel } from './FBExtensionChannel'
import { AbstractExtensionChannel } from './AbstractExtensionChannel'
import axios from 'axios'

export class ExtensionChannelFactory {
  public static async initExtension(): Promise<AbstractExtensionChannel> {
    const lineChannelInit = new Promise<void>((resolve, reject) => {
      const lineLiffAppId =
        window.data.qs && window.data.qs !== undefined && window.data.qs.lineLiffAppId
          ? window.data.qs.lineLiffAppId
          : process.env.lineLiffAppId
      window.liff.init(
        // lineLiffAppId (dev) = 1656618030-mM92Dygv
        // lineLiffAppId (prod-test)= 1656618030-n1OPJNMj
        { liffId: lineLiffAppId },
        () => {
          const idToken = window.liff.getIDToken()
          console.log('hey idToken', idToken)
          axios.interceptors.request.use(function (config: any) {
            const token = idToken
            config.headers.Authorization = `Bearer ${token}`
            config.headers.channeldata = lineLiffAppId
            config.headers.channeltype = 'line'
            console.log('hey config', config)
            return config
          })
          if (!window.liff.isLoggedIn()) {
            window.liff.login()
          }
          resolve()
        },
        (err: any) => {
          console.error(err)
          reject()
        }
      )
    })

    const fbChannelInit = new Promise<void>(resolve => {
      window.extAsyncInit = function () {
        resolve()
      }
    })

    return await lineChannelInit
      .then(() => {
        console.log('initial line')
        return new LineExtensionChannel()
      })
      .catch(async () => {
        console.log('initial facebook')
        return await fbChannelInit.then(() => {
          return new FBExtensionChannel()
        })
      })
  }
}
